import api from "./api"

export const getStoreReconciliations = async () => {
  const { data } = await api.get("/store-reconciliations")
  return data
}

export const getStoreReconciliationById = async (id) => {
  const { data } = await api.get(`/store-reconciliations/${id}`)
  return data
}

export const createStoreReconciliation = async (payload) => {
  const { data } = await api.post("/store-reconciliations", payload)
  return data
}

export const updateStoreReconciliation = async (id, payload) => {
  const { data } = await api.put(`/store-reconciliations/${id}`, payload)
  return data
}

export const deleteStoreReconciliation = async (id) => {
  const { data } = await api.delete(`/store-reconciliations/${id}`)
  return data
}

export const getStoreReconciliationFormData = async () => {
  const { data } = await api.get("/store-reconciliations/form-data")
  return data
}

export const getStoreReconciliationSummary = async (
  storeId,
  periodStart,
  periodEnd
) => {
  const { data } = await api.get("/store-reconciliations/summary", {
    params: {
      store_id: storeId,
      period_start: periodStart,
      period_end: periodEnd,
    },
  })
  return data
}

export const getStoreReconciliationLinks = async (reconciliationId) => {
  const { data } = await api.get(
    `/store-reconciliations/${reconciliationId}/links`
  )
  return data
}

export const updateStoreReconciliationLinks = async (
  reconciliationId,
  payload
) => {
  const { data } = await api.put(
    `/store-reconciliations/${reconciliationId}/links`,
    payload
  )
  return data
}